import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { LanguageSelector, NotificationsButton, Text } from '@reveni-io/reveni-ui'

import SearchTrigger from './SearchTrigger/SearchTrigger'
import UserInfoMenu from './UserInfoMenu/UserInfoMenu'
import * as Styles from './styles'

const Header = ({
  merchantName,
  homeLink,
  showNotifications,
  notificationsCounter,
  notifications,
  onClickMarkAsRead,
  notificationsPreviousPage,
  notificationsNextPage,
  notificationsCountPage,
  notificationsPage,
  notificationsOnChangePage,
  loadingNotifications,
  onClickNotification,
  showNotificationsMenu,
  onClickShowNotificationsMenu,
  userInfo,
  onLogout,
  onEditProfile,
  onOpenSearch,
}) => {
  const { i18n } = useTranslation()

  const handleChangeLanguage = value => {
    localStorage.setItem('language', value)
    i18n.changeLanguage(value)
  }

  return (
    <Styles.Container>
      <Styles.ReveniLogo>
        <Link to={homeLink}>
          <img src="https://cdn.reveni.io/public/img/images/reveni_logo_without_text.svg" alt="reveni" />
        </Link>
      </Styles.ReveniLogo>
      <Styles.InfoContainer>
        <Styles.StoreInfo>
          <Text type="titleM">{merchantName}</Text>
          <SearchTrigger onClick={onOpenSearch} />
        </Styles.StoreInfo>
        <Styles.headerLinks>
          {showNotifications && (
            <NotificationsButton
              counter={notificationsCounter}
              notifications={notifications}
              onClickMarkAsRead={onClickMarkAsRead}
              previousPage={notificationsPreviousPage}
              nextPage={notificationsNextPage}
              countPage={notificationsCountPage}
              page={notificationsPage}
              onChangePage={notificationsOnChangePage}
              loadingNotifications={loadingNotifications}
              onClickNotification={onClickNotification}
              showNotificationsMenu={showNotificationsMenu}
              onClickShowNotificationsMenu={onClickShowNotificationsMenu}
            />
          )}
          <Styles.Divider />
          <UserInfoMenu userInfo={userInfo} onLogout={onLogout} onEditProfile={onEditProfile} />
          <LanguageSelector selectedLanguage={i18n.language} onChange={handleChangeLanguage} />
        </Styles.headerLinks>
      </Styles.InfoContainer>
    </Styles.Container>
  )
}

export default Header
